/**************************************************
 * Nombre:       Formulario_Etiqueta
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {LocalOfferOutlined} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";


const Formulario_Etiqueta = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoTexto Icono={LocalOfferOutlined} nombre={'Nombre Etiqueta'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Etiqueta